var _rect, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcAlbum = function SvgIcAlbum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 13,
    x: 6,
    y: 7.5,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.815 15.21a1.714 1.714 0 0 1 2.513 0l4.315 4.647H6.466a.857.857 0 0 1-.628-1.44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.622 12.822a1.714 1.714 0 0 1 2.613 0l3.578 4.21c.947 1.114.155 2.825-1.306 2.825H9.643z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.643,
    cy: 11.643,
    r: 2.143,
    fill: "currentColor"
  })));
};
export default SvgIcAlbum;